import cfg from './routes.config.json';

export const SITE_URL = cfg.siteUrl;
export const LANGS = cfg.langs;
export const DEFAULT_LANG = cfg.defaultLang;
export const HREFLANG = cfg.hreflang;
export const OG_LOCALE = cfg.ogLocale;

export const LANDING_PAGES = cfg.landingPages;
export const LANDING_SLUG = LANDING_PAGES.haegendorf.slugs;
export const LEGAL_PAGES = cfg.legalPages;
export const PROJECTS_SEGMENT = cfg.projectsSegment;
export const CASE_STUDIES = cfg.caseStudies;

export const caseStudyById = (id) => CASE_STUDIES.find((c) => c.id === id);
export const caseStudyBySlug = (slug) => CASE_STUDIES.find((c) => c.slug === slug);

export const business = {
  ...cfg.business,
  sameAs: [cfg.business.mapUrl, cfg.business.linkedin],
  logo: `${SITE_URL}${cfg.business.logoPath}`,
};

export const homePath = (lang) => `/${lang}`;
export const landingPath = (lang, key = 'haegendorf') => `/${lang}/${LANDING_PAGES[key].slugs[lang]}`;
export const legalPath = (lang, key) => `/${lang}/${LEGAL_PAGES[key].slugs[lang]}`;
export const casePath = (lang, slug) => `/${lang}/${PROJECTS_SEGMENT[lang]}/${slug}`;

export const isValidLang = (lang) => LANGS.includes(lang);
